/**
 * @description 全屏弹窗，用于需要展示页面又不跳转的情况，
 * 它区别于 iframe, 里面放与页面相关的交互
 * @author wayou
 * @date
 */

import React, { Component } from 'react';
import { throttle } from '@umu/umu-util';
import './coverPage.scss';

export interface ICoverPageProps {
    clsName?: string;
    hitBottomCallback?(): void;
}

function hitPanelBottom(offset: number = 180, targetEl?: Element, parentEl?: Element): boolean {
    let ret = false;
    if (!targetEl || !parentEl) {
        return ret;
    }

    const targetHeight = targetEl.clientHeight;
    const parentHeight = parentEl.clientHeight;
    const parentScrollTop = parentEl.scrollTop;

    if (parentHeight + parentScrollTop + offset >= targetHeight) {
        ret = true;
    }

    return ret;
}

class CoverPage<P extends ICoverPageProps, S> extends Component<P, S> {


    private parentRef?: HTMLElement;
    private contentRef?: HTMLElement;

    constructor(props: P) {
        super(props);

        this.bindEvent = this.bindEvent.bind(this);
        this.scrollEvent = throttle(this.scrollEvent.bind(this), 400);
    }

    public componentDidMount() {
        this.bindEvent();
    }

    public componentWillUnmount() {
        if (this.props.hitBottomCallback && this.parentRef) {
            this.parentRef.removeEventListener('scroll', this.scrollEvent, false);
        }
    }

    public bindEvent() {
        if (this.props.hitBottomCallback && this.parentRef) {
            this.parentRef.addEventListener('scroll', this.scrollEvent, false);
        }
    }

    public scrollEvent() {
        if (this.props.hitBottomCallback) {
            if (hitPanelBottom(180, this.contentRef, this.parentRef)) {
                this.props.hitBottomCallback();
            }
        }
    }

    public render() {
        const props = this.props;
        return (
            <div className={'cover-page ' + (props.clsName || '')} ref={(ref) => {
                this.parentRef = ref as HTMLElement;
            }}>
                <div className="cover-page-content" ref={(ref) => {
                    this.contentRef = ref as HTMLElement;
                }}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default CoverPage;
